import { BrowserMultiFormatReader } from "@zxing/browser";
import template from "./badge_scanner.html";
import {
    UPLOAD_PENDING,
    UPLOAD_SUCCESS,
    FACING_MODE_ENVIRONMENT,
} from "../../../common/common.constants";

class BadgeScannerController {
    /*@ngInject*/
    constructor($timeout, $window, $q, $interval) {
        this.$timeout = $timeout;
        this.$window = $window;
        this.$q = $q;
        this.$interval = $interval;
        this.cameraAllowed = true;
    }

    captureVideo() {
        let ctrl = this;
        let options = {
            video: {
                width: { ideal: 1920 },
                height: { ideal: 1080 },
                facingMode: FACING_MODE_ENVIRONMENT,
                frameRate: {
                    ideal: 30,
                },
            },
            audio: false,
        };
        ctrl.$q
            .when(ctrl.$window.navigator.mediaDevices.getUserMedia(options))
            .then(
                function (stream) {
                    ctrl.cameraAllowed = true;
                    ctrl.video.srcObject = stream;
                    ctrl.video.play();
                },
                function () {
                    ctrl.cameraAllowed = false;
                },
            );
    }

    $onInit() {
        let ctrl = this;
        ctrl.lastScannedValue = undefined;
        if (!("BarcodeDetector" in window)) {
            const codeReader = new BrowserMultiFormatReader();
            codeReader
                .decodeFromVideoDevice(
                    undefined,
                    "video",
                    function (result, error, controls) {
                        if (result) {
                            let value = result.text;
                            if (ctrl.lastScannedValue != value) {
                                ctrl.onSuccess({ value });
                            }
                            ctrl.lastScannedValue = value;
                        }
                    },
                )
                .then((controls) => (ctrl.readerControls = controls));
        } else {
            ctrl.video = document.getElementById("video");
            ctrl.captureVideo();
            const barcodeDetector = new BarcodeDetector({
                formats: ["qr_code", "code_128"],
            });
            ctrl.readerInterval = ctrl.$interval(function () {
                barcodeDetector
                    .detect(ctrl.video)
                    .then((barcodes) => {
                        let barcode = barcodes[0];
                        if (barcode) {
                            let value = barcode.rawValue;
                            if (ctrl.lastScannedValue != value) {
                                ctrl.onSuccess({ value });
                            }
                            ctrl.lastScannedValue = value;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 500);
        }
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.readerControls) {
            ctrl.readerControls.stop();
        }

        if (ctrl.video) {
            ctrl.endVideoCapture();
            ctrl.$interval.cancel(ctrl.readerInterval);
        }
    }

    endVideoCapture() {
        let ctrl = this;
        for (let track of ctrl.video.srcObject.getTracks()) {
            track.stop();
        }
    }
}

export default {
    controller: BadgeScannerController,
    template: template,
    bindings: { onSuccess: "&", onError: "&" },
    name: "badgeScanner",
};
